import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginPrompt from '../../components/LoginPrompt';
import { useAuth } from '../../context/AuthContext';
import MoviesBrowse from './MoviesBrowse';
import AdminDashboard from './AdminDashboard';
import { clearMovieBookingRole, getMovieBookingRole, isAdminRole, setMovieBookingRole } from './movieBookingRole';
import './MovieBooking.css';

const MovieEntry = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const navigate = useNavigate();
  const [showRoleModal, setShowRoleModal] = useState(false);
  const [role, setRole] = useState(() => getMovieBookingRole());

  const adminRole = useMemo(() => isAdminRole(user), [user]);

  useEffect(() => {
    if (isAuthenticated && !role) {
      setShowRoleModal(true);
    }
  }, [isAuthenticated, role]);

  const handleRoleSelect = (selectedRole) => {
    setMovieBookingRole(selectedRole);
    setRole(selectedRole);
    setShowRoleModal(false);
  };

  const handleSwitchRole = () => {
    clearMovieBookingRole();
    setRole(null);
    setShowRoleModal(true);
  };

  if (!isAuthenticated) {
    return (
      <LoginPrompt
        feature="movieBooking"
        onClose={() => navigate('/')}
      />
    );
  }

  if (showRoleModal) {
    return (
      <div className="movie-booking-modal">
        <div className="movie-booking-modal-content">
          <h2>Choose your Movie Booking role</h2>
          <p className="movie-booking-note">
            Select Admin if you want to manage theatres and shows. Select User if you want to book tickets.
          </p>
          <div className="movie-booking-actions">
            <button className="movie-booking-button" onClick={() => handleRoleSelect('ADMIN')}>
              Admin (Manage Shows)
            </button>
            <button className="movie-booking-button secondary" onClick={() => handleRoleSelect('USER')}>
              User (Book Tickets)
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (children) {
    return children;
  }

  if (role === 'ADMIN') {
    return <AdminDashboard onSwitchRole={handleSwitchRole} />;
  }

  return <MoviesBrowse onSwitchRole={handleSwitchRole} />;
};

export default MovieEntry;
